/* eslint-disable @typescript-eslint/no-explicit-any -- pre-existing legacy code, not touched in this pass; typing this properly is tracked separately */
import { useTranslation } from "react-i18next";
import { Input } from "components/UI/Input";
import { Tooltip, TooltipContent } from "components/UI/Tooltip";
import styles from "./TruckAxis.module.scss";

interface TransportProps {
  item: any;
  lengthUnits: string;
  weightUnits: string;
}

export const TruckAxis = ({ item, lengthUnits, weightUnits }: TransportProps) => {
  const { t } = useTranslation();
  const tooltipText = `${t(
    "The location of the truck wheels relative to the container and the weight allowed for each axle"
  )}. ${t("F - Front max weight (kg)")}, ${t("F - Front offset (cm)")}, ${t("R - Rear max weight (kg)")}, ${t(
    "R - Rear offset (cm)"
  )}.`;

  return (
    <div className={styles["axle-load-wrapper"]}>
      <div className={styles["axle-load-title-wrap"]}>
        <p>{t("Axle load")}</p>
        <Tooltip
          triggerElement={
            <div className={styles.axisTooltipIcon} aria-label="info">
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.67437 13.528C10.144 13.528 10.3945 13.2296 10.4321 12.7916C10.4321 12.7281 10.4383 12.6647 10.4383 12.6012C10.4759 11.8331 10.764 11.4967 11.7847 10.8175C12.8868 10.0812 13.538 9.24329 13.538 8.03088C13.538 6.1012 11.9851 4.97131 9.96868 4.97131C8.45954 4.97131 7.19461 5.65686 6.65607 6.83752C6.51831 7.12952 6.45569 7.42786 6.45569 7.69446C6.45569 8.13879 6.72496 8.44348 7.19461 8.44348C7.57033 8.44348 7.84586 8.23401 7.96484 7.88489C8.27794 6.81213 8.97928 6.39319 9.8998 6.39319C11.0019 6.39319 11.8661 7.0343 11.8661 8.03723C11.8661 8.90051 11.3589 9.36389 10.4947 9.95422C9.54913 10.608 8.87283 11.3126 8.87283 12.3727V12.7091C8.87283 13.1915 9.16714 13.528 9.67437 13.528ZM9.68063 17.0699C10.2567 17.0699 10.7201 16.6066 10.7201 16.0353C10.7201 15.4576 10.2567 15.0006 9.68063 15.0006C9.11079 15.0006 8.6474 15.4576 8.6474 16.0353C8.6474 16.6066 9.11079 17.0699 9.68063 17.0699Z"
                  fill="#0C263F"
                />
              </svg>
            </div>
          }
          offsetY={8}
        >
          <TooltipContent>{tooltipText}</TooltipContent>
        </Tooltip>
      </div>
      <div className={styles["axle-data-outer-wrapper"]}>
        <div className={styles["axle-data-inner-wrapper"]}>
          <div className={styles.axisField}>
            <Input
              type="number"
              value={item.axisLoad.front.mass}
              placeholder=""
              name={`front_mass-${item.uid}`}
              label={t("F")}
              readOnly
              disabled
              inputClassName={styles.axisInput}
              wrapperClassName={styles.axisInputWrap}
              onChange={() => {
                /* noop */
              }}
            />
            <span className={styles.axisTip}>{weightUnits}</span>
          </div>
          <div className={styles.axisField}>
            <Input
              type="number"
              value={item.axisLoad.rear.mass}
              placeholder=""
              name={`rear_mass-${item.uid}`}
              label={t("R")}
              readOnly
              disabled
              inputClassName={styles.axisInput}
              wrapperClassName={styles.axisInputWrap}
              onChange={() => {
                /* noop */
              }}
            />
            <span className={styles.axisTip}>{weightUnits}</span>
          </div>
          <div className={styles.axisField}>
            <Input
              type="number"
              value={item.axisLoad.front.offset}
              placeholder=""
              name={`front_offset-${item.uid}`}
              label={t("F")}
              readOnly
              disabled
              inputClassName={styles.axisInput}
              wrapperClassName={styles.axisInputWrap}
              onChange={() => {
                /* noop */
              }}
            />
            <span className={styles.axisTip}>{lengthUnits}</span>
          </div>
          <div className={styles.axisField}>
            <Input
              type="number"
              value={item.axisLoad.rear.offset}
              placeholder=""
              name={`rear_offset-${item.uid}`}
              label={t("R")}
              readOnly
              disabled
              inputClassName={styles.axisInput}
              wrapperClassName={styles.axisInputWrap}
              onChange={() => {
                /* noop */
              }}
            />
            <span className={styles.axisTip}>{lengthUnits}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
